import TableService from '../../../services/TableService';
import {
  groupEstoqueFlatRows,
  normalizeGroupedEstoqueRows,
} from '../../../utils/estoqueAggregatedRows';

const GROUPED_URL = 'produtos/estoques/locais/filter/grouped';
const FLAT_URL = 'produtos/estoques/locais/filter';

const isGroupedPayload = (rows) =>
  Array.isArray(rows) && (rows.length === 0 || Array.isArray(rows[0]?.variantes));

/**
 * Busca estoque agrupado por produto. Tenta o endpoint agrupado; em falha ou
 * payload flat, usa o endpoint legado e agrupa no cliente (paginação por variante).
 *
 * @returns {Promise<{ rows: Array, totalRows: number, usedFlatFallback: boolean }>}
 */
export async function fetchEstoqueGrouped(page, pageSize, filterData) {
  const localFilter = filterData?.local;

  try {
    const groupedResponse = await TableService.request(
      `${GROUPED_URL}?p=${page}&s=${pageSize}`,
      filterData
    );
    const groupedRows = groupedResponse?.data?.rows || [];

    if (isGroupedPayload(groupedRows)) {
      return {
        rows: normalizeGroupedEstoqueRows(groupedRows, localFilter),
        totalRows: groupedResponse?.data?.totalRows ?? groupedRows.length,
        usedFlatFallback: false,
      };
    }
  } catch (e) {
    // Endpoint agrupado indisponível — fallback abaixo
  }

  const flatResponse = await TableService.request(
    `${FLAT_URL}?p=${page}&s=${pageSize}`,
    filterData
  );
  const flatRows = flatResponse?.data?.rows || [];

  return {
    rows: groupEstoqueFlatRows(flatRows, localFilter),
    totalRows: flatResponse?.data?.totalRows ?? flatRows.length,
    usedFlatFallback: true,
  };
}
